export async function apiFetch(url, { method = 'GET', body, headers = {} } = {}) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

    const requestHeaders = new Headers(headers);
    requestHeaders.set('Accept', 'application/json');
    requestHeaders.set('X-Requested-With', 'XMLHttpRequest');
    if (csrfToken) {
        requestHeaders.set('X-CSRF-TOKEN', csrfToken);
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
        requestHeaders.delete('Content-Type');
    }

    const response = await fetch(url, {
        method,
        body,
        credentials: 'same-origin',
        headers: requestHeaders,
    });

    let json = null;
    try {
        json = await response.json();
    } catch (error) {
        json = null;
    }

    return { status: response.status, json };
}

export function errorText(json, fallback) {
    if (typeof json?.error === 'string') {
        return json.error;
    }
    if (json?.error && typeof json.error === 'object' && typeof json.error.message === 'string') {
        return json.error.message;
    }
    if (typeof json?.message === 'string') {
        return json.message;
    }
    return fallback;
}
